const defaults = {
    borderRadius: '8px',
    fontFamily: 'Open Sans, Mada, sans-serif !important',
    codeFontFamily:
        'source-code-pro, Menlo, Monaco, Consolas,"Courier New", monospace',
};

export default defaults;
